module.exports = __webpack_public_path__ + "img/waves_br.fe5ab0ee.png";